module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/tutorial1@2x_4c20ee.jpg";